import React from "react";

export const FilterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16.044"
      height="14.586"
      viewBox="0 0 16.044 14.586"
    >
      <g id="filter-icon" transform="translate(-1 -2)">
        <path
          id="Path_225475"
          data-name="Path 225475"
          d="M12.668,4.188a2.188,2.188,0,1,1,2.188,2.188A2.188,2.188,0,0,1,12.668,4.188ZM1.729,4.917h8.751a.729.729,0,0,0,0-1.459H1.729a.729.729,0,0,0,0,1.459ZM6.1,7.1A2.188,2.188,0,0,0,4.048,8.563H1.729a.729.729,0,1,0,0,1.459H4.048A2.188,2.188,0,1,0,6.1,7.1Zm10.21,1.459H10.481a.729.729,0,1,0,0,1.459h5.834a.729.729,0,0,0,0-1.459Zm-8.751,5.1H1.729a.729.729,0,1,0,0,1.459H7.563a.729.729,0,0,0,0-1.459Zm8.751,0H14a2.188,2.188,0,1,0,0,1.459h2.319a.729.729,0,0,0,0-1.459Z"
          fill="#4c5a6a"
        />
      </g>
    </svg>
  );
};
